/**
 * Helpers for deciding whether an edit form still differs from the record it loaded, so that
 * Save can be disabled when there is nothing to save.
 *
 * The comparisons normalise before testing because a form and a record spell "no value"
 * differently: a record arrives from the server with null, while a text input that has been
 * typed in and then cleared hands back "". Comparing those directly leaves a form looking
 * edited after a change has been undone.
 */

/** True when a text field differs from what was loaded. Null, undefined and "" all match. */
export function textChanged(
	currentValue: string | null | undefined,
	valueWhenLoaded: string | null | undefined
): boolean {
	return (currentValue ?? "") !== (valueWhenLoaded ?? "");
}

/**
 * True when a dropdown selection differs from what was loaded. Nothing-selected reaches us as
 * undefined, 0 or "" depending on the control and the model, so all three count as the same.
 */
export function selectionChanged(
	currentValue: string | number | null | undefined,
	valueWhenLoaded: string | number | null | undefined
): boolean {
	return (currentValue || undefined) !== (valueWhenLoaded || undefined);
}
